import Keycloak from 'keycloak-js';
import { config } from './env';
import { ROLES, type Role, rolesFromToken } from './roles';

export type Session = {
  username: string;
  displayName: string;
  roles: Role[];
  logout: () => void;
};

const keycloak = new Keycloak({
  url: config.keycloakUrl,
  realm: config.keycloakRealm,
  clientId: config.keycloakClientId,
});

/** Logs in (redirecting to Keycloak if needed) and returns the session. */
export async function login(): Promise<Session> {
  if (config.authDisabled) {
    return {
      username: 'dev',
      displayName: 'وضع التطوير',
      roles: config.authDisabledRoles.length
        ? ROLES.filter((r) => config.authDisabledRoles.includes(r))
        : [...ROLES],
      logout: () => window.location.reload(),
    };
  }

  await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  });

  const claims = keycloak.tokenParsed as
    | {
        preferred_username?: string;
        name?: string;
        realm_access?: { roles?: string[] };
      }
    | undefined;

  return {
    username: claims?.preferred_username ?? '',
    displayName: claims?.name || claims?.preferred_username || '',
    roles: rolesFromToken(claims),
    logout: () => keycloak.logout(),
  };
}

/**
 * A valid access token (refreshed when it expires within 30 s; tokens only
 * live ~5 minutes). Sends the user back to the login page if the session is
 * gone.
 */
export async function accessToken(): Promise<string | undefined> {
  if (config.authDisabled) return undefined;
  try {
    await keycloak.updateToken(30);
  } catch {
    await keycloak.login();
  }
  return keycloak.token;
}
